import { FC } from 'react'

import { GridItemContent } from 'modules/desktop/modules/files-integration/components/GridViewItem/components/GridItemContent'

import styles from './DropPreviewItem.module.scss'
import { DropPreviewItemProps } from './DropPreviewItem.types'

export const DropPreviewItem: FC<DropPreviewItemProps> = ({
  item,
  row,
  col
}) => (
  <div className={styles.wrapper}>
    <GridItemContent item={item} row={row} col={col} />
  </div>
)
